/**
 * API base, resolved at runtime from the browser's own host so the app works
 * from any origin (127.0.0.1, localhost, LAN IP) without a rebuild.
 *
 * Production hosts map to the API subdomain explicitly: NEXT_PUBLIC_* build
 * inlining is not reliable across Vercel builds (the shipped process.env shim
 * has been observed empty), so the mapping must not depend on it.
 * Override with NEXT_PUBLIC_API_BASE if the API lives elsewhere.
 */
const PRODUCTION_HOSTS: Record<string, string> = {
  "rattskallor.se": "https://api.rattskallor.se",
  "www.rattskallor.se": "https://api.rattskallor.se",
};

export const API_BASE =
  process.env.NEXT_PUBLIC_API_BASE ??
  (typeof window !== "undefined"
    ? (PRODUCTION_HOSTS[window.location.hostname] ??
        `${window.location.protocol}//${window.location.hostname}:8000`)
    : "http://127.0.0.1:8000");

/**
 * Fetch against the Rättskällor.se API.
 * Pass a Clerk session token (from `useAuth().getToken()`) to authenticate
 * protected endpoints; the API verifies it as a Bearer JWT.
 */
export async function apiFetch(
  path: string,
  init?: RequestInit & { token?: string },
): Promise<Response> {
  const headers = new Headers(init?.headers ?? {});
  if (init?.token) headers.set("Authorization", `Bearer ${init.token}`);
  return fetch(`${API_BASE}${path}`, { ...init, headers, credentials: "include" });
}
